<template>
  <v-container>
  <v-card elevation="2" class="my-4 mx-4" v-if="currentOrden" color="#F5F5F5">
    <v-card-title style="color: #B08836"  class="font-weight-bold">
      <h2 class="heading font-weight-bold">  {{ formTitle }}</h2>
      <v-spacer></v-spacer>
      <v-btn color="#0A4A79" class="mr-1" dark :to="roleUser == 'secacuerdos' || roleUser == 'magistrado' ? '/escritos/panel' : '/panel'" small>
        <v-icon small class="mr-3">mdi-arrow-left</v-icon>
        Ir a Panel
      </v-btn>
      <v-btn v-if="(roleUser == 'magistrado' || roleUser == 'superadmin') && (!currentOrden.secretario_id) " color="#0A4A79" dark to="/reporte/magistrado" small>
        <v-icon small class="mr-3">mdi-file</v-icon>
        Ir a Reporte
      </v-btn>
    </v-card-title>
    <v-card-text style="color: grey" class="font-weight-black">
      <v-row class="mb-n5">
        <v-col cols="12" md="6">
          <div v-if="currentOrden.sala_id < 12">
            <h4 v-if="currentOrden.numero_completo != 0"><span style="color: darkslategrey">NUM. DE TOCA: {{currentOrden.numero_completo}}</span></h4>
            <h4 v-else ><span style="color: #225882">NUM. DE TOCA: </span> <span style="color: #676767" class="ml-2"><u>En proceso de asignación </u></span><br>
            </h4>
          </div>
          <div  v-if="currentOrden.sala_id == 12">
            <h4 v-if="currentOrden.numero_completo != 0 || currentOrden.sala_id == 12"><span style="color: darkslategrey">NUM. DE ASUNTO: {{currentOrden.numero_completo}}</span></h4>
            <h4 v-else ><span style="color: #225882">NUM. DE ASUNTO: </span> <span style="color: #676767" class="ml-2"><u>En proceso de asignación </u></span><br>
            </h4>
          </div>
          <span class="font-weight-small  mr-3" style="color: #225882">ESTATUS:</span>
                    <u v-if="currentOrden.status==2" style="color: green">Registrada</u>
                    <u v-if="currentOrden.status==3" style="color: green">Contestada</u><br>
        </v-col>
        <v-col cols="12" md="6" class="text-right">
          <span v-if="!currentOrden.secretario_id" class="font-weight-small black--text mr-3">Abogado:</span>
          <span v-else-if="currentOrden.secretario_id" class="font-weight-small black--text mr-3">Secretario:</span>
          <u v-if="!currentOrden.secretario_id">{{ currentOrden.abogado }}</u>
          <!-- <span v-else-if="currentOrden.secretario_id" class="font-weight-small black--text mr-3">Secretario_id:</span> -->
          <u v-else-if="currentOrden.secretario_id">{{ currentOrden.secretario }}</u><br>
          <span class="font-weight-small black--text mr-3">Email:</span>
          <u v-if="!currentOrden.secretario_id">{{ currentOrden.abogado_email }}</u>
          <u v-else-if="currentOrden.secretario_id">{{ currentOrden.secretario_email }}</u><br>
          <span class="font-weight-small black--text mr-3" v-if="currentOrden.contestacion != null">
            Firmó Secretario:
          </span>
          <u v-if="currentOrden.contestacion != null">
            {{currentOrden.contestacion.secretario}}
          </u><br v-if="currentOrden.contestacion != null">
          <!-- <span v-if="currentOrden.juez" class="font-weight-small black--text mr-3">Juez:</span><u>{{currentOrden.juez}}</u><br> -->
          <!--<span class="font-weight-small black--text mr-3">Carpeta Inv.</span><span style="color: green"><u>{{currentOrden.numero_promocion}}</u></span><br>-->
          <span class="font-weight-small black--text mr-3">Fecha de envío:</span><u>{{currentOrden.created_at | formatDate}}</u><br>
          <!-- <span v-if="currentOrden.fecha_turno" class="font-weight-small black--text mr-3">Fecha Turno:</span><u>{{currentOrden.fecha_turno | formatDate}}</u><br> -->
          <span v-if="currentOrden.fecha_contestacion" class="font-weight-small black--text mr-3">Fecha Contestación:</span><u>{{currentOrden.fecha_contestacion | formatDate}}</u><br>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- <v-divider inset></v-divider>-->
    <v-divider inset></v-divider>

    <v-card-text>
      <v-row
        class="my-1">
        <v-col cols="12" md="5" v-if="currentOrden.tipo ==1" align="center">
          <p class="text-center font-weight-bold" style="color: #225883; font-size: 15px">Asunto</p>
          <strong class="mx-4" style="color: black">
             <!-- {{currentOrden.delitos[0].delito}} -->
          </strong>
        </v-col >
        <!-- <v-divider vertical v-show="currentOrden.tipo ==1"></v-divider>
        <v-col cols="12" :md="currentOrden.tipo == 1 ? 6 : 12" align="center" >
          <p class="text-center font-weight-bold" style="color: #225882; font-size: 15px">Descripción</p>
          <strong class="mx-4 " style="color: black">
            {{currentOrden.solicitud_escrita}}
          </strong>
        </v-col> -->
      </v-row>

      <!-- SECCION ESCRITO INICIAL -->
      <v-row v-if="currentOrden.url">
        <v-col cols="12">
          <v-toolbar
            color="#676767"
          dense
          flat
            dark
            class="pt-n7"
          >
        <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
      </v-toolbar>

        <table class="table">
        <!-- <template v-slot:default> -->
          <thead>
            <tr>
              <th class="text-left font-weight-bold format_table" style="color: #225883; font-size: 15px; width: 50%">
                Documento
              </th>
              <th class="text-left font-weight-bold format_table" style="color: #225883; font-size: 15px">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="currentOrden.url"
                >
              <td class="font-weight-black format_table" style="color: black;">{{formTitle}}</td>
              <td class="format_table">
                <!--<v-btn small @click="getFile(item)"> Ver documento </v-btn>-->
                <v-btn
                  x-small
                  color="#C51162"
                  dark
                  @click="getFile(currentOrden, 'promocion')"
                >
                  <v-icon left x-small>
                    mdi-file
                  </v-icon>
                  Ver documento
                </v-btn>&nbsp;
                <v-btn
                  x-small
                  color="indigo"
                  dark
                  @click="getAcuse(currentOrden, 'promocion')"
                  style="min-width: 132px;"
                >
                  <v-icon left x-small class="ml-n9">
                    mdi-file
                  </v-icon>
                  Ver acuse
                </v-btn>

              </td>
            </tr>
          </tbody>
        <!-- </template> -->
      </table>
      </v-col>
      </v-row>
      <!-- END ESCRITO INICIAL-->

      <!-- DOCUMENTOS ANEXOS -->
      <v-row v-if="currentOrden.sala_id < 11 && !currentOrden.secretario_id">
        <v-col cols="12">
          <v-toolbar
          color="#676767"
          dense
          flat
          dark

          >
        <v-icon>mdi-file-outlined</v-icon>
        <v-toolbar-title>Documentos Anexos</v-toolbar-title>
      </v-toolbar>

        <table class="table">
        <!-- <template v-slot:default> -->
          <thead>
            <tr>
              <th class="text-left font-weight-bold format_table" style="color: #225883; font-size: 15px; width: 50%">
                Nombre del documento
              </th>
              <th class="text-left font-weight-bold format_table" style="color: #225883; font-size: 15px">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody>

            <tr
              v-for="item in currentOrden.documentos_abogado"
              :key="item.id"
              v-if="item.signed !=2"
            >
              <td class="font-weight-black format_table" style="color: black;"> {{ item.nombre }}</td>
              <td class="format_table">
               <!-- <v-btn small @click="getFile(item)"> Ver documento</v-btn>-->
                <v-btn
                  x-small
                  color="indigo"
                  dark
                  @click="getFile(item, 'documento')"
                >
                  <v-icon left x-small>
                    mdi-file
                  </v-icon>
                  Ver documento
                </v-btn>&nbsp;
              </td>

            </tr>
          </tbody>
        <!-- </template> -->
      </table>
      </v-col>
      </v-row>
      <!-- END DOCUMENTOS ANEXOS -->

      <!-- SHOW MAGISTRADOS MULTIFIRMA -->
      <v-row v-if="(currentOrden.proceso_multifirma >= 1 || currentOrden.secretario_id) && roleUser != 'abogado'">
        <v-col cols="12">
          <v-toolbar
          color="#676767"
          dense
          flat
          dark
          >
        <v-icon>mdi-file-outlined</v-icon>
        <v-toolbar-title>Firmantes</v-toolbar-title>
      </v-toolbar>

      <table class="table">
      <!-- <template v-slot:default> -->
        <thead>
          <tr>
            <th class="text-left font-weight-bold format_table" style="color: #225883; font-size: 15px; width: 50%">
              Magistrados
            </th>
            <th class="text-left font-weight-bold format_table" style="color: #225883; font-size: 15px; width: 50%">
              Firmas
            </th>
            <!-- <th class="text-left font-weight-bold" style="color: #225883; font-size: 15px">
              <v-btn
                x-small
                color="indigo"
                dark
                @click=""
                style="min-width: 132px;"
              >
                <v-icon left x-small>
                  mdi-file
                </v-icon>
                Ver Acuerdo
              </v-btn>
            </th> -->
          </tr>
        </thead>
        <tbody>

          <tr
            v-for="item in firmasList"
            :key="item.id"
            v-if="item.signed !=2"
          >
            <td v-if="item.magistrado.segundo_apellido" class="font-weight-black format_table" style="color: black;">
              {{ item.magistrado.nombre+' '+item.magistrado.primer_apellido+' '+item.magistrado.segundo_apellido }}
            </td>
            <td v-else class="font-weight-black format_table" style="color: black;"> {{ item.magistrado.nombre+' '+item.magistrado.primer_apellido }}</td>
            <td class="font-weight-black format_table" style="color: black;">
              <h3 v-if="item.firmado == 1">
                <v-icon color="green">
                  mdi-file-check
                </v-icon>
                Firmado
              </h3>
              <h3 v-else>
                <v-icon color="red">
                  mdi-file-remove
                </v-icon>
                Pendiente de Firma
              </h3>
            </td>
          </tr>
        </tbody>
      <!-- </template> -->
    </table>
      </v-col>
      </v-row>
      <!-- END MAGISTRADOS MULTIFIRMA -->

      <!-- CONTESTACIÓN -->
      <v-row v-if="currentOrden.status==3">
        <v-col cols="12">
          <v-toolbar
          color="#676767"
          dense
          flat
          dark
          >
        <v-toolbar-title>Contestación</v-toolbar-title>
      </v-toolbar>

        <table class="table">
        <!-- <template v-slot:default> -->
          <thead>
            <tr>
              <th class="text-left font-weight-bold format_table" style="color: #225883; font-size: 15px; width: 50%">
                Documento
              </th>
              <th class="text-left font-weight-bold format_table" style="color: #225883; font-size: 15px">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="currentOrden.contestacion.url"
            >
              <td class="font-weight-black format_table" style="color: black;"> Contestación</td>
              <td class="format_table">
                <!--<v-btn small @click="getFile(item)"> Ver documento</v-btn>-->

                <v-btn
                  x-small
                  color="green"
                  dark
                  @click="getFile(currentOrden, 'contestacion')"
                >
                  <v-icon left x-small>
                    mdi-file
                  </v-icon>
                  Ver documento
                </v-btn>&nbsp;
                <v-btn
                  v-if="!currentOrden.fecha_amparo && !currentOrden.fecha_sentencia"
                  x-small
                  color="indigo"
                  dark
                  @click="getAcuse(currentOrden, 'contestacion')"
                  style="min-width: 132px;"
                >
                  <v-icon left x-small class="ml-n9">
                    mdi-file
                  </v-icon>
                  Ver acuse
                </v-btn>
              </td>

            </tr>
          </tbody>
        <!-- </template> -->
      </table>
      </v-col>
      </v-row>
      <!-- END CONTESTACIÓN-->

      <v-divider inset class="mt-4"></v-divider>
      <br>
      <v-row class="mt-1">
        <v-col cols="12" align="right">
          <!-- <v-btn
            v-if="(currentOrden.status == 2 && (roleUser == 'superadmin' || roleUser == 'secacuerdos')) && (currentOrden.proceso_multifirma <= 1)"
            color="primary"
            dark
            to="/multifirma/create"
          >
          <v-icon dark left>mdi-pen</v-icon>
             <span v-if="currentOrden.proceso_multifirma == 0">Enviar a Firmas</span>
             <span v-else>Actualizar Firmantes</span>
          </v-btn>&nbsp; -->
          <!-- <v-btn
            v-if="(currentOrden.status == 2 && (roleUser == 'superadmin' || roleUser == 'secacuerdos')) && (currentOrden.proceso_multifirma == 1 || currentOrden.secretario_id) && acuerdo_firmado"
            color="success"
            dark
            to="/multifirma/contestacion"
          >
          <v-icon dark left>mdi-file-send-outline </v-icon>
             {{btnTitle}}
          </v-btn> -->
          <v-btn
            v-if="(currentOrden.status == 2 && (roleUser == 'secacuerdos' || roleUser == 'superadmin' || roleUser == 'secretariageneral' || roleUser == 'presidencia')) && ((currentOrden.proceso_multifirma == 0 || !currentOrden.proceso_multifirma) && !currentOrden.secretario_id)"
            color="success"
            dark
            to="/contestacion"
          >
          <v-icon dark left>mdi-file-send-outline </v-icon>
             Contestar
          </v-btn>
        </v-col>
        <v-col v-if="(currentOrden.status == 3 && roleUser == 'abogado' && currentOrden.contestacion.leida == 0)" cols="12" align="right">
          <v-btn
            color="blue"
            dark
            @click="leido()"
          >
          <v-icon dark left>mdi-email-open </v-icon>
             Marcar como Leído
          </v-btn>
        </v-col>
        <!-- <v-col v-if="(currentOrden.proceso_multifirma == 1 && roleUser == 'magistrado')" cols="12" align="right">
          <v-btn
            color="blue"
            dark
            to="/firma/magistrado"
          >
          <v-icon dark left>mdi-pen</v-icon>
             Firmar Acuerdo
          </v-btn>
        </v-col> -->
        <!-- <v-col v-if="(!currentOrden.juez && currentOrden.status==1 && roleUser == 'superadmin') || (!currentOrden.juez && currentOrden.status==1 && roleUser == 'oficialia')" cols="12" md="10" align="right">
          <v-btn class="mx-2" dark style="background-color:#AF8936" @click="asignarJuez()">
            <v-icon dark left>mdi-account-arrow-right</v-icon>
            Asignar Juez
          </v-btn>
        </v-col> -->
      </v-row>
      <!-- E-FIRMA -->
      <v-dialog v-model="eFirmaDialog" max-width="600px" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-2">
            <span>AGREGAR FIRMA ELECTRONICA</span>
          </v-card-title>
          <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
            <v-card-text>
              <v-text-field
                v-model="efirma.user"
                label="Usuario"
                :rules="[v => !!v || 'Este campo es requerido']"
              ></v-text-field>
              <v-text-field
                v-model="efirma.password"
                label="Contraseña"
                :rules="[v => !!v || 'Este campo es requerido']"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" dark @click="eFirmaDialog = false">Cancelar</v-btn>
              <v-btn color="yellow darken-2" dark @click="add_eFirma()" :loading="loading">Guardar</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <!-- VIABILIDAD -->
      <v-row v-if="messages_viabilidad.length">
        <v-col cols="12">
          <div>
            <v-alert
              v-model="alert"
              color="red"
              border="left"
              elevation="2"
              colored-border
              icon="mdi-alert"
            >
              Es necesario realizar las siguientes acciones para enviar la solicitud: <br><br>
              <ul v-for="message in messages_viabilidad">
                <li>{{message}}</li>
              </ul>
            </v-alert>
          </div>
        </v-col>
      </v-row>
      <!-- END VIABILIDAD -->

      <v-dialog
        v-model="progress"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="#0A4A79"
          dark
        >
          <v-card-text>
            Cargando Archivo
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- ASIGNAR JUEZ -->
      <!-- <v-row justify="space-around">
        <v-col cols="auto">
         <v-dialog
           v-model="juezDialog"
           max-width="750"
         >
           <template v-slot:default="juezDialog">
             <v-card>
               <v-toolbar
                 color="grey darken-2"
                 dense
                 dark
               >Asignar Juez</v-toolbar>
              <br>
               <v-card-text>
                 <v-form @submit.prevent="saveJuez" ref="form" v-model="valid" lazy-validation>
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="12">
                          <v-select
                            :items="listJueces"
                            v-model="juez"
                            label="Juez"
                            prepend-icon="mdi-gavel"
                            item-value="id"
                            item-text="name"
                            return-object
                            outlined
                            dense
                            require
                            :rules="[v => !!v|| 'Seleccione el juez']"
                            >
                          </v-select>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
               </v-card-text>
               <v-card-actions class="justify-end">
                 <v-btn
                  color="red darken-1" dark
                  @click="juezDialog.value = false; juez = ''"
                 >Cancelar</v-btn>
                 <v-btn
                  color="blue darken-2" class="white--text"
                  :loading="loading"
                  :disabled="!valid"
                  @click="saveJuez"
                 >Guardar</v-btn>
               </v-card-actions>
             </v-card>
           </template>
         </v-dialog>
       </v-col>
     </v-row> -->
     <!-- END ASIGNAR JUEZ -->
    </v-card-text>
  </v-card>
</v-container>
</template>

<script>
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";

  export default {
    data(){
      return{
        currentOrden:'',
        // juezDialog:false,
        progress: false,
        valid: true,
        loading:false,
        alert:true,
        url_leido:'',
        messages_viabilidad:[],
        valid: true,
        loading: false,
        eFirmaDialog: false,
        acuerdo_firmado: false,
        efirma:{
          user: '',
          password: ''
        },
        url:'',
        juez:'',
        promocion_id:'',
        listDocumentos: [
            {
              name: 'Acta de Matrimonio',
            },
            {
              name: 'Acta de Nacimiento',
            },
            {
              name: 'Régimen Patrimonial',
            },
        ]
      }
    },
    computed: {
      formTitle () {
        if (this.currentOrden.sala_id === 12) {
          return 'Asunto Laboral'
        }else if (this.currentOrden.sala_id === 13) {
          return 'Buzón Presidencia'
        }
        if (this.currentOrden.fecha_sentencia) {
          return 'Sentencia'
        }
        if (this.currentOrden.fecha_amparo) {
          return 'Amparo'
        }
        return 'Promoción'
      },
      btnTitle () {
        if (this.currentOrden.secretario_id) {
          return 'agregar firma secretario'
        }
        return 'agregar firma secretario y contestar'
      },
      ...mapGetters(["currentUser", "roleUser", "firmasList", "listJueces"]),
    },
    mounted() {
      this.currentOrden =  JSON.parse(localStorage.getItem("currentOrden"))
      if (this.currentOrden.proceso_multifirma >= 1 || this.currentOrden.secretario_id) {
        this.getFirmas();
      }
      //this.showPromocion()
    },
    methods:{
      showPromocion() {
        this.$store.dispatch("SHOW_PROMOCION", { url: "/promocion/" + this.currentOrden.id })
          .then((response) => {
          })
          .catch(err => {
            console.log(err);
            this.$swal({
              title: 'Error!!!',
              icon: 'error',
              timer: 1000,
            })
          });
      },

      leido() {
      if(this.currentOrden.sala_id == 12) this.url_leido = "/expediente/"+this.currentOrden.id+"/contestacion/"+this.currentOrden.contestacion.id+"/leida"
      if(this.currentOrden.sala_id == 13) this.url_leido = "/buzon/"+this.currentOrden.id+"/contestacion/"+this.currentOrden.contestacion.id+"/leida"
      if(this.currentOrden.sala_id < 12)  this.url_leido = "/promocion/"+this.currentOrden.id+"/contestacion/"+this.currentOrden.contestacion.id+"/leida"

        this.$store.dispatch("SET_LEER_CONTESTACION", { url: this.url_leido })
          .then((response) => {
            // console.log(response.data);
            Swal.fire({
              icon: 'success',
              title: 'Contestación Leída',
              confirmButtonText: "Aceptar",
              timer: 1000,
            })
            this.showPromocion()
            this.$router.push('/panel')
          })
          .catch(err => {
            console.log(err);
            this.$swal({
              title: 'Error!!!',
              icon: 'error',
              timer: 1000,
            })
          });
      },

      add_eFirma(){
        if (this.$refs.form.validate()) {
          this.loading = true;
          // this.$store.dispatch("LOGIN", {
          //   usuario: this.efirma.user,
          //   password: this.efirma.password
          // }).then(response => {
          this.$store.dispatch("E_FIRMA", { url: "/efirma/connect", data: this.efirma }).then(response => {
            console.log('eFirma', response);
            this.$swal({
              icon: 'success',
              title: 'Firma electrónica agregada con exito!!!',
              confirmButtonText: "Aceptar"
            })
            this.loading = false;
            this.eFirmaDialog = false
          })
          .catch(error => {
            console.log(error);
          });
        }
      },
      getFirmas() {
        var url = "/multifirma/"+ this.currentOrden.id +"/firmas"
        if (this.currentOrden.fecha_sentencia) {
          url = "/sentencia/"+ this.currentOrden.id +"/firmas"
        }
        if (this.currentOrden.fecha_amparo) {
          url = "/amparo/"+ this.currentOrden.id +"/firmas"
        }
        // console.log(url);
        this.$store.dispatch("GET_FIRMAS",  { url: url })
          .then(response => {
            // console.log(response.data);
            var firmas = response.data.data.firmas
            var countfirmas = 0
            firmas.forEach(firma => {
              if (firma.firmado == 1) {
                countfirmas ++
              }
            });
            // console.log(countfirmas);
            // console.log(firmas.length);
            if (firmas.length == countfirmas) {
              this.acuerdo_firmado = true
            } else {
              this.acuerdo_firmado = false
            }
        })
        .catch(error => {
          console.log(error);
        });
      },
      // sendPromocion() {
      //   var promocion_id = this.currentOrden.id
      //   this.$store.dispatch("SEND_PROMOCION",  { url: "/promocion/"+promocion_id+"/enviar", data: promocion_id } )
      //   .then(response => {
      //     console.log(response)
      //     Swal.fire({
      //       icon: 'success',
      //       title: 'Solicitud Enviada',
      //       confirmButtonText: "Aceptar",
      //       timer: 3000,
      //     })
      //     this.$router.push('/ordenes')
      //   })
      //     .catch(err => {
      //       this.loading = false
      //       console.log("el error de nuevo",err);
      //     });
      // },
      getFile(item ,tipo){
        if (tipo == 'promocion'){
        if(this.currentOrden.sala_id == 12) this.url = "/expediente/"+item.id+"/file"
        if(this.currentOrden.sala_id == 13) this.url = "/buzon/"+item.id+"/file"
        if(this.currentOrden.sala_id < 12)  this.url = "/promocion/"+item.id+"/file"
        }

        if (tipo == 'documento') this.url = "/orden/"+item.promocion_id+"/documento/"+item.id
        if (tipo == 'multifirma') this.url = "/promocion/"+item.id+"/previo-multifirma"

        if (tipo == 'contestacion'){
          // url get file firmado contestacion sentencia
          if(this.currentOrden.sala_id == 12) this.url = "/expediente/"+ item.contestacion.id + "/contestacion/file"
          if(this.currentOrden.sala_id == 13) this.url = "/buzon/"+ item.contestacion.id + "/contestacion/file"
          if(this.currentOrden.sala_id < 12) this.url = "/promocion/"+ item.contestacion.id + "/contestacion/file"
          if(this.currentOrden.fecha_sentencia) this.url = "/sentencia/"+ item.contestacion.id + "/contestacion/file"
          if(this.currentOrden.fecha_amparo) this.url = "/amparo/"+ item.contestacion.id + "/contestacion/file"
        }
        // console.log(this.url);
        this.progress = true
        this.$store.dispatch("GET_FILE", { url: this.url }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('target' ,'_blank');
            document.body.appendChild(link);
            link.click();
            this.progress = false
          })
          .catch(err => {
            console.log(err);
          });
      },
      getAcuse(item, tipo){
        item.id = this.currentOrden.id
        if (tipo == 'promocion'){
          if(this.currentOrden.sala_id < 12)  this.url = '/promocion/'+ item.id + '/acuse'
          if(this.currentOrden.sala_id == 12) this.url = '/expediente/'+ item.id + '/acuse'
          if(this.currentOrden.sala_id == 13) this.url = '/buzon/'+ item.id + '/acuse'
        }
        if (tipo == 'contestacion'){
          // url get acuse contestacion sentencia
          if(this.currentOrden.sala_id < 12)  this.url = '/promocion/'+ item.id + '/contestacion/acuse'
          if(this.currentOrden.sala_id == 12) this.url = '/expediente/'+ item.id + '/contestacion/acuse'
          if(this.currentOrden.sala_id == 13) this.url = '/buzon/'+ item.id + '/contestacion/acuse'
          if(this.currentOrden.fecha_sentencia) this.url = "/sentencia/"+ item.id + "/contestacion/acuse"
          if(this.currentOrden.fecha_amparo) this.url = "/amparo/"+ item.id + "/contestacion/acuse"
        }
        this.progress = true
        this.$store.dispatch("GET_ACUSE", { url: this.url }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('target' ,'_blank');
          document.body.appendChild(link);
          link.click();
          this.progress = false
        })
        .catch(err => {
          console.log(err);
        });
      },
      // getJueces() {
      //   this.$store.dispatch("GET_JUECES",  { url: "/jueces" } ).then(response => {
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
      // },
      // asignarJuez(item) {
      //   this.getJueces()
      //   this.juezDialog = true
      //   this.promocion_id=this.currentOrden.id
      // },
      // saveJuez() {
      //   if (this.$refs.form.validate()) {
      //     this.loading = true
      //
      //     Swal.fire({
      //     title: '¿Desea turnar la solicitud a '+ this.juez.name + '?',
      //     icon: 'warning',
      //     showCancelButton: true,
      //     confirmButtonColor: '#3085d6',
      //     cancelButtonColor: '#d33',
      //     confirmButtonText: 'Aceptar',
      //     cancelButtonText: 'Cancelar',
      //     reverseButtons: true
      //   }).then((result) => {
      //     if (result.isConfirmed) {
      //       const promocion = {
      //         promocion_id:this.promocion_id,
      //         juez_id:this.juez.id,
      //       }
      //       this.$store.dispatch("SET_JUEZ",  { url: "/promocion/"+this.promocion_id+"/juez/"+this.juez.id, data: promocion } )
      //       .then(response => {
      //         Swal.fire({
      //           icon: 'success',
      //           title: 'Juez Asignado',
      //           confirmButtonText: "Aceptar",
      //         })
      //         this.showPromocion()
      //         this.juezDialog = false
      //       })
      //         .catch(err => {
      //           this.loading = false
      //           console.log("el error de nuevo",err);
      //         });
      //     } else {
      //       this.loading=false
      //       }
      //     })
      //   }
      // }
    }
  }
</script>

<style media="screen">
  .theme--light.v-input input, .theme--light.v-input textarea {
    color: rgb(62 61 61 / 87%);
  }
  .table {
    border-collapse:collapse;
    width: 100%;
  }

  .format_table {
    /* border: 1px solid #dddddd; */
    text-align: left;
    padding: 8px;
  }
</style>
